import { useMutation } from '@apollo/client';
import { Coupon, UpdateCouponStatusInput } from '../../shared/types';
import { UpdateCouponStatusResponse, UpdateCouponStatusRequest, CITRIN_UPDATE_COUPON_STATUS } from '..';

type UpdateMutationFunction = (request: UpdateCouponStatusInput) => Promise<Coupon>;
export const useUpdateCouponStatusMutation = (): UpdateMutationFunction => {
    const [mutation, { client }] = useMutation<UpdateCouponStatusResponse, UpdateCouponStatusRequest>(
        CITRIN_UPDATE_COUPON_STATUS
    );
    return async (request) => {
        const { data } = await mutation({ variables: { request } });
        const updated = data?.CITRIN_MGT_updateCouponStatus;
        //   updateGetVehiculeCache(client, updated, ...(keys(request) as any));
        return updated;
    };
};
